const conversationTypes = {
	
	ADD_NEW_CONVERSATION_START: 'ADD_NEW_CONVERSATION_START',
	FETCH_CONVERSATIONS_START: 'FETCH_CONVERSATIONS_START',
	// FETCH_VENDORS_START: 'FETCH_VENDORS_START',
	SET_CONVERSATIONS: 'SET_CONVERSATIONS',
	DELETE_CONVERSATION_START: 'DELETE_CONVERSATION_START',
	FETCH_CONVERSATION_START: 'FETCH_CONVERSATION_START',
	SET_CONVERSATION: 'SET_CONVERSATION',
	FETCH_CONVERSATION_SERVICE_START: 'FETCH_CONVERSATION_SERVICE_START',
	FETCH_CUSTOMER_CONVERSATION_START: 'FETCH_CUSTOMER_CONVERSATION_START'
  };
  
  export default conversationTypes;